/* az-pdp-v3.js — Reveal + Accordion — max 80 lines */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal */
  var els = document.querySelectorAll('.v3-r');
  if (reduced || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('is-v'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-v'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Accordion */
  document.querySelectorAll('.spc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.spc-item');
      var panel = item.querySelector('.spc-panel');
      var open = item.classList.contains('is-open');
      var siblings = item.parentElement.querySelectorAll('.spc-item.is-open');
      siblings.forEach(function (s) {
        if (s !== item) {
          s.classList.remove('is-open');
          s.querySelector('.spc-btn').setAttribute('aria-expanded', 'false');
          s.querySelector('.spc-panel').style.maxHeight = '0';
        }
      });
      if (open) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = '0';
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
})();
